<script>
  import { dispatchCustomEvent, SIGN_UP } from "$lib/utils/events";
  import { getRecaptcha } from "$lib/utils/getRecaptcha";
  import { validatePassword } from "$lib/utils/validatePassword";
  import { VerifyEmailAddress } from "$lib/utils/verifyEmailAddress";

  /**@type {string}*/
  let name = "";
  /**@type {string}*/
  let lastName = "";
  /**@type {string}*/
  let email = "";
  /**@type {string}*/
  let password = "";
  /**@type {string}*/
  let repeatPassword = "";
  /**@type {import ('$lib/types/errorMessages').errorMessage | null}*/
  let error;


  /**@param {SubmitEvent | HTMLFormElement}e*/
  const submit = async (e) => {
    if (name && lastName == "") return;
    const formData = new FormData(e.currentTarget);
    try {
      let recaptcha = await getRecaptcha();
      const responseStream = await fetch("/customers/signup", {
        method: "POST",
        headers: {
          "X-ReCaptcha": recaptcha,
        },
        body: formData,
      });
      const response = await responseStream.json();
      if (response && responseStream.status == 200) {
        dispatchCustomEvent(SIGN_UP, email)
        /** @type {HTMLDialogElement | ??}*/
        let dialog = document.getElementById("create-account");
        dialog.close();
      }
    } catch (error) {
      error = { msg: error, error: true };
    }
  };
  $: {
    repeatPassword;
    error = validatePassword(password, repeatPassword);
  }

  const openSignIn =()=>{
    /**@type {HTMLDialogElement | ??}*/
    let thisModal = document.querySelector('#create-account');
    thisModal.close()
    /**@type {HTMLDialogElement | ??}*/
    let signInModal = document.querySelector('#signin-account');
    signInModal.showModal()
  }

</script>

<div class="form-content">
  <h1>Create Account</h1>
  {#if !VerifyEmailAddress(email).isValid && VerifyEmailAddress(email).msg && email.length > 0}
    <p class="message red">{VerifyEmailAddress(email).msg}</p>
  {:else if error && repeatPassword.length > 0}
    <p class="message red">{error.msg}</p>
  {:else}
    <p class="message"></p>
  {/if}
  <form on:submit|preventDefault={(e) => submit(e)} method="POST">
    <div class="box">
      <span>Personal Information</span>
      <div class="flex-inputs">
        <input
          autocomplete="off"
          type="text"
          name="firstname"
          placeholder="Name"
          class="information"
        />
        <input
          autocomplete="off"
          type="text"
          name="lastname"
          class="information"
          placeholder="Last Name"
        />
      </div>
    </div>
    <input
      autocomplete="off"
      type="e-mail"
      bind:value={email}
      name="email"
      placeholder="E-mail"
      class:wrong={!VerifyEmailAddress(email).isValid && email.length > 0}
    />
    <div class="password-content flex-inputs">
      <input
        autocomplete="off"
        type="password"
        name="password"
        placeholder="Password"
        bind:value={password}
      />
      <input
        autocomplete="off"
        type="password"
        name="repeat-password"
        placeholder="Confirm Password"
        bind:value={repeatPassword}
      />
    </div>
      <div class="isSubscribre">
        <input type="checkbox" name="is_subscribed" id="subscribe" />
        <label for="subscribe">Please tick here if you would like to receive exclusive promotions, new product launch information and tips & tricks!</label>
      </div>
    <div></div>
    <button type="button" class="signin" on:click={openSignIn}>
      <span>Do you have an account?</span>&#x20;
      <span>Please Sign In</span>
    </button>
    <button type="submit" class="btn-action-url" disabled={error?.error}>
      <span>Sign Up</span>
    </button>
  </form>
</div>

<style>
  .form-content {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: 7rem 6rem 1fr;
    justify-items: center;
    gap: 1rem;
  }
  .form-content h1 {
    font-size: clamp(4rem, 5svw, 5rem);
    font-family: sirenia;
    color: var(--orange);
    text-wrap: wrap;
  }
  .message {
    font-size: 1.6rem;
    opacity: 0;
    transition: all 500ms ease;
    text-align: center;
    width: 80%;
    border-radius: 4rem;
    padding: 0 3rem;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .message.red {
    color: var(--white);
    background-color: var(--red);
    opacity: 1;
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 60rem;
    margin: 0 auto;
    gap: 1rem;
    overflow-y: auto;
    padding-bottom: 2rem;
  }
  form .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    gap: 2rem;
    padding: 0 0 2rem 0;
  }
  form .box span {
    line-height: 1;
    font-size: 3rem;
    text-indent: 1rem;
    color: var(--orange);
    font-weight: 700;
  }
  form .flex-inputs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    width: 100%;
  }
  form input {
    border: none;
    width: 100%;
    padding: 0.5rem 0;
    text-indent: 1rem;
    border-bottom: 0.2rem solid var(--orange);
    font-size: 1.8rem;
    font-family: sirenia;
    outline: none;
    color: var(--orange);
  }
  form input.information {
    padding: 0.5rem 0;
    font-size: 1.6rem;
    text-transform: capitalize;
  }
  form .password-content {
    width: 100%;
    position: relative;
  }
  form input.wrong {
    color: var(--red);
    border-bottom: 0.2rem solid var(--red);
  }
  form .signin {
    text-decoration: none;
    color: var(--orange);
    padding: 1rem;
    margin-top: 4rem;
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
  }
  form .signin span {
    text-wrap: nowrap;
    font-size: clamp(1.6rem, 3svw, 2.2rem);
  }
  form .signin::before {
    content: "";
    width: 100%;
    height: 0.2rem;
    background-color: var(--orange);
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 1rem;
    transition: all 300ms ease;
    cursor: pointer;
  }
  form .signin:hover::before {
    width: 105%;
    transform: translateX(-50%);
  }
  .isSubscribre{
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .isSubscribre input{
    width: 20px;
    height: 20px;
    border: 2px solid var(--orange);
  }
  .isSubscribre label{
    font-size: 16px;
    line-height: 1;
  }
  @media (max-width: 767px) {
    form .flex-inputs {
      flex-direction: column;
    }
  }
</style>
